import * as React from "react";
import { StyledCard, Content, Column } from "./ComparisonLists.styles";

interface IProps {
  data?: any;
  type?: string;
  selectedLesson?: string;
  isTeacher?: boolean;
}

class ComparisonLists extends React.Component<IProps> {
  public static defaultProps = {
    type: "duration",
  };
  public state = {};

  constructor(props) {
    super(props);
  }

  // public renderGeneralComparisonList() {
  //   const lists = new Array();
  //   const { data, type, selectedLesson } = this.props;
  //   const lesson = data.Lessons[Number(selectedLesson)];

  //   if (type === "duration") {
  //     lists.push({
  //       title: "Warp Speed!",
  //       items: lesson.ShortestDuration.map((item) => item.Name),
  //     });

  //     lists.push({
  //       title: "Quite Slow…",
  //       items: lesson.LongestDuration.map((item) => item.Name),
  //     });
  //   } else if (type === "rank") {
  //     lists.push({
  //       title: "Flying so high!",
  //       titleClass: "yellow",
  //       items: lesson.HighestRanked.map((item) => item.Name),
  //     });

  //     lists.push({
  //       title: "Needs a boost!",
  //       titleClass: "red",
  //       items: lesson.LowestRanked.map((item) => item.Name),
  //     });
  //   }

  //   if (!selectedLesson) {
  //     return null;
  //   }

  //   return (
  //     <StyledCard>
  //       <Content>
  //         {lists.map((list: any) => {
  //           return (
  //             <Column key={list.title}>
  //               <h3 className={list.titleClass}>{list.title}</h3>
  //               <div>
  //                 {list.items.map((item) => (
  //                   <p key={item}>{item}</p>
  //                 ))}
  //               </div>
  //             </Column>
  //           );
  //         })}
  //       </Content>
  //     </StyledCard>
  //   );
  // }

  public renderTeacherComparisonLists() {
    const lists = new Array();
    const { data, type, selectedLesson } = this.props;
    console.log({ data });
    //  const lesson = data.Lessons[Number(selectedLesson)];

    if (type === "duration") {
      lists.push({
        title: "Warp Speed!",
        description: "Students who were the quickest to complete the lesson.",
        items: data.shortest_duration.map((item) => `${item.name}`),
      });

      lists.push({
        title: "Quite Slow…",
        description: "Students who took the longest to complete the lesson.",
        items: data.longest_duration.map((item) => `${item.name}`),
      });
    } else if (type === "rank") {
      lists.push({
        title: "Flying so high!",
        titleClass: "yellow",
        description: "Students who achieved high scores in the lesson.",
        items: data.highest_rank.map((item) => `${item.name}`),
      });

      lists.push({
        title: "Needs a boost!",
        titleClass: "red",
        description: "Students who achieved low scores in the lesson.",
        items: data.lowest_rank.map((item) => `${item.name}`),
      });
    }

    if (!selectedLesson) {
      return null;
    }

    return (
      <StyledCard>
        <Content>
          {lists.map((list: any) => {
            return (
              <Column key={list.title}>
                <h3 className={list.titleClass}>{list.title}</h3>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "lighter",
                    textAlign: "center",
                    width: "90%",
                  }}
                >
                  {list.description}
                </p>
                <div>
                  {list.items.map((item) => (
                    <p key={item}>{item}</p>
                  ))}
                </div>
              </Column>
            );
          })}
        </Content>
      </StyledCard>
    );
  }

  public render() {
    const { isTeacher } = this.props;

    return this.renderTeacherComparisonLists();
    // if(isTeacher) {return this.renderTeacherComparisonLists()}
    // return this.renderGeneralComparisonList();
  }
}

export default ComparisonLists;



// WEBPACK FOOTER //
// ./src/components/DataCentre/ComparisonLists/ComparisonLists.tsx